export default "__VITE_ASSET__C9iz$_rv__"